import jqRequest from '../jqRequest'
import selfMediaUrls from '../urls/selfMedia.js'

export default {
  // 媒体号入驻申请时获取媒体号分类树
  getSelfmediaCategoryTreeForApply(data) {
    return jqRequest.requestWithToken(selfMediaUrls.getSelfmediaCategoryTreeForApply, data,'get');
  },
  // 省市地址
  getTotalAmcAreaList(data) {
    return jqRequest.requestWithToken(selfMediaUrls.getTotalAmcAreaList, data,'');
  },
  // 媒体号入驻申请，提交申请信息
  addApplyForSelfMediaFreChannel(data) {
    return jqRequest.requestWithToken(selfMediaUrls.addApplyForSelfMediaFreChannel, data,'post','',{ 'Content-Type': 'application/json' });
  },
  // 媒体号入驻申请，获取申请列表
  listApplyForSelfMediaFreChannel(data) {
    return jqRequest.requestWithToken(selfMediaUrls.listApplyForSelfMediaFreChannel, data,'get');
  },
  // 媒体号入驻申请，修改申请信息
  updateApplyForSelfMediaFreChannel(data) {
    return jqRequest.requestWithToken(selfMediaUrls.updateApplyForSelfMediaFreChannel, data,'post','',{ 'Content-Type': 'application/json' });
  },
  // 媒体号入驻申请，删除申请
  delApplyForSelfMediaFreChannel(data) {
    return jqRequest.requestWithToken(selfMediaUrls.delApplyForSelfMediaFreChannel, data,);
  },
  // 媒体号入驻申请，驳回修改后再次提交申请
  backForSubmit(data) {
    return jqRequest.requestWithToken(selfMediaUrls.backForSubmit, data,);
  },
  
}